import React from 'react';
import { OfferBanner } from '../components/OfferBanner';
import { HeroSection } from '../components/HeroSection';
import { EmotionalConnection } from '../components/EmotionalConnection';
import { AvatarPains } from '../components/AvatarPains';
import { SolutionBenefits } from '../components/SolutionBenefits';
import { ProductOffer } from '../components/ProductOffer';
import { Bonuses } from '../components/Bonuses';
import { BreedGallery } from '../components/BreedGallery';
import { Testimonials } from '../components/Testimonials';
import { FAQ } from '../components/FAQ';
import { Footer } from '../components/Footer';
import { FloatingCTA } from '../components/FloatingCTA';
export function LandingPage() {
  return <div className="min-h-screen font-body text-deep-brown selection:bg-soft-rose selection:text-white" data-id="element-390">
      <OfferBanner data-id="element-391" />
      <main data-id="element-392">
        <HeroSection data-id="element-393" />
        <EmotionalConnection data-id="element-394" />
        <AvatarPains data-id="element-395" />
        <SolutionBenefits data-id="element-396" />
        <BreedGallery data-id="element-397" />
        <ProductOffer data-id="element-398" />
        <Bonuses data-id="element-399" />
        <Testimonials data-id="element-400" />
        <FAQ data-id="element-401" />
      </main>
      <Footer data-id="element-402" />
      <FloatingCTA data-id="element-403" />
    </div>;
}